
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>G H Raisoni Memorial Buldhana District Badminton Championship 2025

                    </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-7">
                <p>We are delighted to share the successful completion of the G H Raisoni Memorial Buldhana District Badminton Championship 2025, held on 20th and 21st April 2025 at the Indoor Sports Facility Center, J.K.V.M, Malkapur, District Buldhana.</p>

                <p>This prestigious event, presented by Raisoni Foundation and organized under the aegis of the Maharashtra Badminton Association, witnessed an electrifying atmosphere as *110 talented participants* (including boys , girls , Men's and women's) from across the district came together to celebrate the spirit of badminton.
                </p>
                <p>Over the course of two action-packed days, the championship showcased incredible talent, discipline, and sportsmanship. The energy, enthusiasm, and dedication of the players made this tournament not only competitive but truly inspiring.</p>
                <p>
                    We were honored to have *Ms. Manisha Lakhani* and *Mr. Khizer Hayat Khan* as the Chief Guests, whose gracious presence and motivating words added prestige to the event and encouraged every athlete to bring out their best.</p>
                <p>We extend our heartfelt congratulations to all the participants for their outstanding performances and sincere efforts. Your passion for the sport and commitment to excellence were instrumental in making this event a memorable and meaningful success.</p>
                <p>This championship has once again highlighted the importance of providing platforms for young and aspiring athletes to grow, compete, and shine. We look forward to continuing our support for such initiatives that foster talent and sportsmanship in our communities.</p>
                <p>*We Congratulate  everyone who contributed to making the G H Raisoni Memorial Buldhana District Badminton Championship 2025 a grand success!*</p>

            </div>
            <div class="col-md-5">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/batminton-tournament-buldhana-25-1.avif"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-1.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-1.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-2.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-2.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-3.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-3.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-4.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-4.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badimnton-25-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </div>

</section>
